import IconBase from './base';

const SlidersHorizontal = (props: any) => (
  <IconBase {...props}>
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M10.5 6h9.75M10.5 6a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 6H7.5m3 12h9.75m-9.75 0a1.5 1.5 0 11-3 0m3 0a1.5 1.5 0 10-3 0M3.75 18H7.5M3.75 12H9m1.5 0h10.5'
    />
  </IconBase>
);

export default SlidersHorizontal;
